import { Container, Wrapper } from "./styled";
import { Breadcrumbs } from "@/widgets/Breadcrumbs";

interface ContentContainerProps {
  children: React.ReactNode;
  showNav?: boolean;
  title?: string;
  breadcrumbsTitle?: string;
}

export const ContentContainer = ({ children, showNav = true, title, breadcrumbsTitle }: ContentContainerProps) => {
  return (
    <Wrapper>
      {showNav && title && <Breadcrumbs breadcrumbsTitle={breadcrumbsTitle} title={title} />}
      <Container>
        {children}
      </Container>
    </Wrapper>
  );
};